module.exports = __webpack_public_path__ + "ac6f0599e1311bebd9e52f37bb84ef19.svg";